// FR — French. Translates en.js key for key (PM-0185).
//
// Every key here must exist in en.js (EN is the source catalogue) and every EN
// key must be translated here; tests/i18n.test.js asserts both directions. A
// key that ever goes missing falls back to English (translator.js), never to
// Persian.
//
// French typography is in the values themselves: « » with a no-break space
// inside, U+00A0 before ':' and '%', U+202F before ; ! ?, the typographic
// apostrophe ’. Count-neutral wording throughout — this translator has no
// plural lookup, so a {{count}} string must read correctly for 0, 1 and many.
// Brand and code values are kept as they are: 'Parsina', 'Parseh',
// 'PARSINA-1404-XXXX', the language endonyms.

export const fr = {
  // ── app ──────────────────────────────────────────────────────────────────
  'app.title': 'Parsina — Module dentaire',

  // ── nav / chrome ─────────────────────────────────────────────────────────
  'nav.brand.name': 'Parsina',
  'nav.brand.panel': 'Chirurgie dentaire',
  'nav.items.today': 'Aujourd’hui',
  'nav.items.patients': 'Patients',
  'nav.items.credits': 'Crédit',
  'nav.items.profile': 'Profil',
  'nav.sidebar.collapse': 'Réduire le menu',
  'nav.sidebar.expand': 'Développer le menu',
  'nav.sidebar.logout': 'Se déconnecter',
  'nav.sidebar.editProfile': 'Profil',
  'nav.clinic.label': 'Clinique',
  'nav.account.menuLabel': 'Compte',
  'nav.account.parsina': 'Compte Parsina',
  'nav.account.parsinaHint': 'Nom, mot de passe, langue',
  'nav.credits.label': 'Votre crédit Parseh',
  'nav.credits.topUp': 'Recharger en Parseh',
  'nav.clinicSwitch.label': 'Accéder à l’espace clinique',
  'nav.landmark.primary': 'Menu principal',
  'nav.landmark.content': 'Contenu',

  // ── common ───────────────────────────────────────────────────────────────
  'common.actions.cancel': 'Annuler',
  'common.actions.retry': 'Réessayer',
  'common.loading': 'Chargement',
  'common.actions.save': 'Enregistrer',
  'common.actions.saving': 'Enregistrement…',
  'common.actions.back': 'Retour',
  'common.actions.close': 'Fermer',
  'common.actions.clearFilters': 'Effacer les filtres',
  'common.actions.join': 'Rejoindre',
  'common.state.pleaseWait': 'Veuillez patienter…',
  'common.labels.phone': 'Téléphone',
  'common.labels.country': 'Pays',
  'common.labels.nationalId': 'N° national',
  'common.labels.fileNumber': 'N° de dossier',
  'common.labels.none': '—',
  'common.gender.male': 'Homme',
  'common.gender.female': 'Femme',
  'common.marital.single': 'Célibataire',
  'common.marital.married': 'Marié(e)',
  'common.marital.divorced': 'Divorcé(e)',
  'common.marital.widowed': 'Veuf / veuve',
  'common.units.years': '{{count}} ans',
  'common.units.years_one': '{{count}} an',
  'common.units.minute': 'min',
  'common.units.second': 'secondes',
  'common.units.toman': 'toman',
  'common.units.tomans': 'tomans',
  'common.punct.colon': ' :',
  'common.voice.start': 'Dicter',
  'common.voice.stop': 'Arrêter l’enregistrement',
  'common.voice.listening': 'En écoute',
  'common.voice.priceTitle': '5 Parseh par minute d’enregistrement, arrondi à la minute supérieure.',
  'common.voice.inlineTranscribing': 'Transcription…',
  'common.voice.error.denied': 'L’accès au micro a été refusé',
  'common.voice.error.no-mic': 'Aucun micro n’a été détecté',
  'common.voice.error.unsupported': 'Ce navigateur ne peut pas enregistrer de son',
  'common.voice.error.insecure': 'L’enregistrement ne fonctionne que sur une connexion sécurisée (HTTPS)',
  'common.voice.error.credits': 'Crédit Parseh insuffisant',
  'common.voice.error.auth': 'Votre session n’est plus valide. Veuillez vous reconnecter',
  'common.voice.error.onboarding': 'Terminez d’abord votre inscription',
  'common.voice.error.unavailable': 'Le service de reconnaissance vocale est indisponible',
  'common.voice.error.timeout': 'La transcription a pris trop de temps',
  'common.voice.error.generic': 'Impossible d’enregistrer le son',

  // ── mobile shell ─────────────────────────────────────────────────────────
  'mobile.greeting': 'Bienvenue,',
  'mobile.showMore': 'Afficher plus',
  'mobile.close': 'Fermer',

  // ── auth / boot ──────────────────────────────────────────────────────────
  'auth.checking': 'Connexion…',
  'auth.loading': 'Chargement de votre espace…',
  'auth.loopError': 'La connexion redirige en boucle. Effacez votre session et réessayez, ou contactez l’assistance.',
  'auth.loopTitle': 'Échec de la connexion',
  'auth.checkingHint': 'Cela ne prend qu’un instant',
  'auth.stuck': 'Pas de redirection ?',
  'auth.manualSignIn': 'Cliquez ici',
  'auth.retry': 'Réessayer',
  'auth.signOut': 'Se déconnecter',
  'auth.bootFailed.title': 'Démarrage impossible',
  'auth.bootFailed.body': 'Votre espace n’a pas pu être chargé. C’est généralement temporaire.',
  'auth.session.expiringTitle': 'Votre session va bientôt expirer',
  'auth.session.expiringBody': 'Prolongez-la pour continuer à travailler sans interruption.',
  'auth.session.staySignedIn': 'Continuer à travailler',
  'auth.session.expiredTitle': 'Votre session a expiré',
  'auth.session.expiredBody': 'Reconnectez-vous pour continuer. Cette page n’a pas été fermée — vous y reviendrez ensuite.',
  'auth.session.signInAgain': 'Se reconnecter',
  'auth.session.returnNotice': 'Tout ce que vous avez déjà enregistré est conservé. Avant de vous reconnecter, notez ce qui n’est pas encore enregistré à l’écran.',

  // ── errors ───────────────────────────────────────────────────────────────
  'errors.generic': 'Une erreur s’est produite.',
  'errors.load.today': 'La journée n’a pas pu être chargée.',
  'errors.load.patients': 'La liste des patients n’a pas pu être chargée.',
  'errors.load.patient': 'Ce dossier n’a pas pu être chargé.',
  'errors.load.profile': 'Votre profil n’a pas pu être chargé.',
  'errors.load.drugs': 'La recherche dans le référentiel des médicaments a échoué.',
  'errors.credits.title': 'Crédit IA insuffisant',
  'errors.credits.body': 'La vérification des interactions nécessite du crédit. Rechargez-le depuis la page « Crédit » — la prescription elle-même n’est pas bloquée.',

  // ── today (امروز) ─────────────────────────────────────────────────────────
  'today.title': 'Aujourd’hui',
  'today.date.today': 'Aujourd’hui',
  'today.date.prev': 'Jour précédent',
  'today.date.next': 'Jour suivant',
  'today.date.pick': 'Choisir une date',
  'today.counts.total': 'Rendez-vous',
  'today.counts.here': 'À la clinique',
  'today.counts.scheduled': 'Planifiés',
  'today.counts.completed': 'Vus',
  'today.counts.cancelled': 'Annulés',
  'today.counts.cancelledLine': 'Annulés : {{count}}',
  'today.notice.liveQueue': 'La salle d’attente en direct ne s’affiche que pour aujourd’hui. Les autres jours affichent la liste des rendez-vous planifiés.',
  'today.status.scheduled': 'Planifié',
  'today.status.arrived': 'Arrivé',
  'today.status.in_visit': 'Au fauteuil',
  'today.status.completed': 'Vu',
  'today.status.cancelled': 'Annulé',
  'today.status.no_show': 'Non honoré',
  'today.blocks.queue': 'Salle d’attente',
  'today.blocks.upcoming': 'À venir',
  'today.blocks.done': 'Terminés',
  'today.next.title': 'Patient suivant',
  'today.next.at': 'à {{time}}',
  'today.next.service': 'Prestation : {{name}}',
  'today.next.serviceVisit': 'Séance',
  'today.next.serviceMore': '+{{count}} en plus',
  'today.empty.title': 'Aucun rendez-vous planifié ce jour-là',
  'today.empty.description': 'Les rendez-vous sont planifiés par l’accueil de la clinique et s’affichent ici automatiquement.',
  'today.error.title': 'Le planning du jour est indisponible',
  'today.queue.positionNext': 'Suivant',
  'today.queue.position': 'N° {{position}}',
  'today.queue.waited': '{{count}} min d’attente',
  'today.queue.waitedHours': '{{hours}} h d’attente',
  'today.queue.waitedHoursMinutes': '{{hours}} h {{minutes}} min d’attente',
  'today.queue.elapsed': '{{count}} min au fauteuil',
  'today.queue.elapsedHours': '{{hours}} h au fauteuil',
  'today.queue.elapsedHoursMinutes': '{{hours}} h {{minutes}} min au fauteuil',
  'today.row.visit': 'Séance',
  'today.row.visitFor': 'Ouvrir la séance de {{name}}',
  'today.row.open': 'Ouvrir le dossier',
  'today.row.openFor': 'Ouvrir le dossier de {{name}}',
  'today.row.walkIn': 'Réservation rapide',
  'today.row.unknownPatient': 'Patient sans nom',
  'today.readOnlyNote': 'La planification, l’annulation et l’ordre de passage relèvent de l’accueil de la clinique. Cet espace affiche les mêmes rendez-vous.',

  // ── patients (بیماران) ────────────────────────────────────────────────────
  'patients.title': 'Patients',
  'patients.subtitle': 'Le registre des patients de la clinique — les mêmes patients que ceux enregistrés à l’accueil',
  'patients.search.placeholder': 'Nom, téléphone, n° national ou n° de dossier',
  'patients.search.hint': 'Saisissez au moins deux caractères pour rechercher.',
  'patients.count': 'Patients : {{count}}',
  'patients.columns.name': 'Patient',
  'patients.columns.phone': 'Téléphone',
  'patients.columns.fileNumber': 'N° de dossier',
  'patients.columns.nationalId': 'N° national',
  'patients.empty.title': 'Aucun patient pour l’instant',
  'patients.empty.description': 'Les patients enregistrés à l’accueil de la clinique apparaissent ici.',
  'patients.emptyFiltered.title': 'Aucun résultat',
  'patients.emptyFiltered.description': 'Aucun patient ne correspond à cette recherche.',
  'patients.noClinic.title': 'Vous n’avez encore rejoint aucune clinique',
  'patients.noClinic.description': 'Le registre des patients appartient à une clinique. Rejoignez-en une depuis votre profil, avec son code d’invitation.',
  'patients.noClinic.action': 'Accéder au profil',
  'patients.pendingClinic.title': 'Votre rattachement n’a pas encore été approuvé',
  'patients.pendingClinic.description': 'Vous avez demandé à rejoindre la clinique, qui doit approuver votre demande avant d’ouvrir son registre des patients. Le statut figure sur votre profil.',
  'patients.error.title': 'La liste des patients est indisponible',

  // ── patient workspace ────────────────────────────────────────────────────
  'patient.tabs.summary': 'Résumé',
  'patient.tabs.history': 'Antécédents',
  'patient.tabs.sectionsLabel': 'Sections du dossier',
  'patient.actions.prescribe': 'Prescrire',
  'patient.notFound.title': 'Dossier introuvable',
  'patient.notFound.description': 'Ce patient n’existe pas ou ne vous est pas accessible.',
  'patient.error.title': 'Ce dossier est indisponible',
  'patient.stats.age': 'Âge',
  'patient.stats.allergies': 'Allergies',
  'patient.stats.medications': 'Médicaments',
  'patient.summary.demographics': 'Informations',
  'patient.summary.allergies': 'Allergies',
  'patient.summary.noAllergies': 'Aucune allergie enregistrée.',
  'patient.severity.mild': 'Légère',
  'patient.severity.moderate': 'Modérée',
  'patient.severity.severe': 'Sévère',
  'patient.conditionStatus.active': 'Actif',
  'patient.conditionStatus.inactive': 'Inactif',
  'patient.conditionStatus.resolved': 'Résolu',
  'patient.conditionStatus.remission': 'En rémission',
  'patient.photo.open': 'Afficher en grand la photo de {{name}}',
  'patient.photo.alt': 'Photo de profil de {{name}}',
  'patient.summary.allergyWarning': 'Allergies enregistrées — vérifiez-les avant de prescrire.',
  'patient.fields.birthDate': 'Date de naissance',
  'patient.fields.gender': 'Sexe',
  'patient.fields.maritalStatus': 'Situation familiale',
  'patient.fields.bloodType': 'Groupe sanguin',
  'patient.fields.job': 'Profession',
  'patient.fields.insurance': 'Assurance',
  'patient.fields.height': 'Taille',
  'patient.fields.createdAt': 'Date d’enregistrement',
  'patient.history.conditions': 'Diagnostics',
  'patient.history.medications': 'Médicaments',
  'patient.history.noConditions': 'Aucun diagnostic enregistré.',
  'patient.history.noMedications': 'Aucun médicament enregistré.',
  'patient.history.prescribedOn': 'Prescrit le {{date}}',

  // ── prescription (نسخه) ──────────────────────────────────────────────────
  'prescription.title': 'Ordonnance',
  'prescription.subtitle': 'Pour {{name}}',
  'prescription.search.label': 'Ajouter un médicament',
  'prescription.search.placeholder': 'Rechercher un médicament…',
  'prescription.search.searching': 'Recherche…',
  'prescription.search.empty': 'Aucun médicament ne correspond.',
  'prescription.search.hint': 'Saisissez au moins deux caractères.',
  'prescription.search.results': 'Médicaments trouvés : {{count}}.',
  'prescription.item.dose': 'Dose',
  'prescription.item.frequency': 'Fréquence',
  'prescription.item.duration': 'Durée',
  'prescription.item.note': 'Note',
  'prescription.item.remove': 'Retirer {{name}}',
  'prescription.empty.title': 'Aucun médicament prescrit pour l’instant',
  'prescription.empty.description': 'Recherchez un médicament ci-dessus pour ajouter le premier.',
  'prescription.save': 'Enregistrer l’ordonnance',
  'prescription.saveConfirm': 'Confirmer et enregistrer',
  'prescription.saving': 'Enregistrement…',
  'prescription.saved': 'Ordonnance enregistrée.',
  'prescription.saveFailed': 'L’ordonnance n’a pas pu être enregistrée.',
  'prescription.savePartial': 'Médicaments enregistrés : {{saved}} sur {{total}}.',
  'prescription.allergies.title': 'Allergies enregistrées',
  'prescription.interactions.title': 'Vérification des interactions',
  'prescription.interactions.checking': 'Vérification…',
  'prescription.interactions.none': 'Aucune interaction détectée entre ces médicaments.',
  'prescription.interactions.needsTwo': 'Ajoutez un deuxième médicament pour lancer la vérification des interactions.',
  'prescription.interactions.unavailable': 'La vérification des interactions est indisponible pour le moment. La prescription n’est pas bloquée.',
  'prescription.interactions.severity.high': 'Élevée',
  'prescription.interactions.severity.moderate': 'Modérée',
  'prescription.interactions.severity.low': 'Faible',
  'prescription.interactions.type.interaction': 'Interaction',
  'prescription.interactions.type.contraindication': 'Contre-indication',
  'prescription.interactions.type.allergy': 'Allergie',
  'prescription.interactions.type.black_box': 'Mise en garde majeure',
  'prescription.history.title': 'Prescriptions antérieures',
  'prescription.history.empty': 'Aucune prescription antérieure.',

  // ── profile ──────────────────────────────────────────────────────────────
  'profile.title': 'Profil',
  'profile.subtitle': 'Votre identité, vos cliniques et vos plages horaires',
  'profile.sections.label': 'Sections du profil',
  'profile.sections.identity': 'Identité',
  'profile.sections.clinics': 'Cliniques',
  'profile.sections.presence': 'Plages horaires',
  'profile.sections.appearance': 'Apparence et langue',
  'profile.fields.fullName': 'Nom complet',
  'profile.fields.medicalCode': 'N° d’inscription à l’Ordre',
  'profile.fields.specialty': 'Spécialité',
  'profile.fields.bio': 'À propos de vous',
  'profile.specialtyValue': 'Chirurgie dentaire',
  'profile.medicalCodeLocked': 'Le n° d’inscription à l’Ordre a été saisi lors de la création du compte et ne peut pas être modifié. Contactez l’assistance Parsina pour le faire corriger.',
  'profile.specialtyLocked': 'Cet espace est destiné aux dentistes : la spécialité y est donc fixe. La modifier ailleurs fermera l’accès de votre compte à cet espace.',
  'profile.saved': 'Profil enregistré.',
  'profile.noChanges': 'Aucune modification.',
  'profile.saveFailed': 'Le profil n’a pas pu être enregistré.',
  'profile.duplicateCode': 'Ce n° d’inscription à l’Ordre est déjà associé à un autre compte.',
  'profile.clinics.empty': 'Vous n’avez encore rejoint aucune clinique.',
  'profile.clinics.status.pending': 'En attente d’approbation',
  'profile.clinics.status.active': 'Actif',
  'profile.clinics.visitDuration': 'Créneau de {{count}} min',
  'profile.clinics.activeScope': 'Clinique active',
  'profile.clinics.activeScopeHint': 'Les pages « Aujourd’hui » et « Patients » affichent cette clinique.',
  'profile.clinics.joinTitle': 'Rejoindre une clinique',
  'profile.clinics.joinHint': 'Demandez le code d’invitation au responsable de la clinique.',
  'profile.clinics.joinPlaceholder': 'Code d’invitation',
  'profile.clinics.joined': 'Vous avez rejoint {{name}}.',
  'profile.clinics.notFound': 'Aucune clinique ne correspond à ce code d’invitation.',
  'profile.clinics.joinFailed': 'Impossible de rejoindre la clinique.',
  'profile.presence.empty': 'La clinique n’a pas encore défini de plages horaires pour vous.',
  'profile.presence.oneOff': 'Ponctuelle',
  'profile.presence.inactive': 'Désactivée',
  'profile.presence.readOnly': 'Les plages horaires sont définies par la clinique ; cet espace se contente de les afficher.',
  'profile.presence.days.0': 'Lundi',
  'profile.presence.days.1': 'Mardi',
  'profile.presence.days.2': 'Mercredi',
  'profile.presence.days.3': 'Jeudi',
  'profile.presence.days.4': 'Vendredi',
  'profile.presence.days.5': 'Samedi',
  'profile.presence.days.6': 'Dimanche',
  'profile.appearance.theme': 'Couleur d’accent',
  'profile.appearance.fontSize': 'Taille du texte',
  'profile.appearance.language': 'Langue',
  'profile.appearance.saved': 'Préférence enregistrée.',
  'profile.appearance.failed': 'La préférence n’a pas été enregistrée sur le serveur.',
  'profile.theme.default': 'Bleu Parsina',
  'profile.theme.teal': 'Turquoise',
  'profile.theme.ocean': 'Bleu profond',
  'profile.theme.slate': 'Gris bleu',
  'profile.fontSize.small': 'Petite',
  'profile.fontSize.medium': 'Moyenne',
  'profile.fontSize.large': 'Grande',
  'profile.language.fa': 'فارسی',
  'profile.language.en': 'English',
  'profile.language.fr': 'Français',
  'profile.language.de': 'Deutsch',

  // ── onboarding ───────────────────────────────────────────────────────────
  'onboarding.title': 'Module dentaire Parsina',
  'onboarding.subtitle.step1': 'Inscrivez-vous une seule fois pour que votre compte puisse être identifié',
  'onboarding.subtitle.clinic': 'Rattachez-vous à la clinique où vous exercez',
  'onboarding.subtitle.done': 'Tout est prêt',
  'onboarding.progress.step1': 'Inscription',
  'onboarding.progress.clinic': 'Clinique',
  'onboarding.progress.done': 'Terminé',
  'onboarding.step1.fullName': 'Nom complet',
  'onboarding.step1.fullNamePlaceholder': 'Dr Maryam Ahmadi',
  'onboarding.step1.medicalCode': 'N° d’inscription à l’Ordre',
  'onboarding.step1.medicalCodePlaceholder': 'ex. : 123456',
  'onboarding.step1.specialty': 'Spécialité',
  'onboarding.step1.bio': 'À propos de vous (facultatif)',
  'onboarding.step1.submit': 'Continuer',
  'onboarding.step1.specialtyNote': 'Cet espace est le module dentaire : la spécialité est donc définie pour vous.',
  'onboarding.clinic.choiceTitle': 'Votre cabinet ou votre clinique',
  'onboarding.clinic.choiceDescription': 'Si vous avez votre propre cabinet, enregistrez-le ici. Si vous exercez dans une autre clinique, rejoignez-la avec un code d’invitation.',
  'onboarding.clinic.ownTitle': 'Enregistrer mon propre cabinet',
  'onboarding.clinic.ownBody': 'Pour un cabinet personnel. Vous en serez propriétaire.',
  'onboarding.clinic.joinTitle': 'Rejoindre une clinique existante',
  'onboarding.clinic.joinBody': 'Avec le code d’invitation que la clinique vous a remis.',
  'onboarding.clinic.back': 'Retour',
  'onboarding.clinic.ownName': 'Nom du cabinet',
  'onboarding.clinic.ownNamePlaceholder': 'Cabinet dentaire du Dr Ahmadi',
  'onboarding.clinic.ownCity': 'Ville (facultatif)',
  'onboarding.clinic.ownAddress': 'Adresse (facultatif)',
  'onboarding.clinic.ownPhone': 'Téléphone du cabinet (facultatif)',
  'onboarding.clinic.create': 'Enregistrer le cabinet',
  'validation.clinicName': 'Saisissez le nom du cabinet.',
  'onboarding.clinic.alreadyExists': 'Un cabinet est déjà enregistré pour ce compte.',
  'onboarding.clinic.currency': 'Devise du cabinet',
  'onboarding.clinic.currencyHint': 'Les tarifs et les plans de traitement sont enregistrés dans cette devise. Elle ne peut être modifiée dans l’espace clinique que jusqu’à l’enregistrement du premier montant.',
  'onboarding.clinic.currencyIrr': 'Toman (IRR)',
  'onboarding.clinic.currencyMismatch': 'Un cabinet est déjà enregistré pour ce compte, en {{currency}}. Choisissez cette devise, ou modifiez-la dans l’espace clinique.',
  'onboarding.clinic.setupIncomplete': 'Le cabinet a été créé, mais sa devise n’a pas pu être définie dans la comptabilité. Ne l’enregistrez pas une deuxième fois — contactez l’assistance Parsina pour terminer la configuration.',
  'onboarding.clinic.title': 'Rejoindre votre clinique',
  'onboarding.clinic.description': 'Avec le code d’invitation de la clinique, vous accédez à vos rendez-vous et au registre des patients de la clinique. Vous pourrez aussi le faire plus tard depuis votre profil.',
  'onboarding.clinic.placeholder': 'Code d’invitation',
  'onboarding.clinic.join': 'Rejoindre',
  'onboarding.clinic.skip': 'Plus tard',
  'onboarding.done.title': 'Bienvenue',
  'onboarding.done.body': 'Votre espace dentaire est prêt. La page « Aujourd’hui » affiche les rendez-vous que la clinique planifie pour vous.',
  'onboarding.done.enter': 'Accéder à l’espace',

  // ── validation ───────────────────────────────────────────────────────────
  'validation.medicalCode': 'Saisissez votre n° d’inscription à l’Ordre.',
  'validation.fullName': 'Saisissez votre nom complet.',
  'validation.invitationCode': 'Saisissez le code d’invitation.',
  'validation.officePhone': 'Le numéro de téléphone du cabinet est incomplet. Corrigez-le ou videz le champ.',
  'validation.phone.tooShort': 'Ce numéro ({{country}}) est trop court — exemple : {{example}}',
  'validation.phone.tooLong': 'Ce numéro ({{country}}) est trop long — exemple : {{example}}',
  'validation.phone.invalid': 'Ce numéro n’est pas valide.',

  // ── چارت دندان / odontogram ──────────────────────────────────────────────
  'patient.tabs.plan': 'Plan de traitement',
  'patient.plan.empty.title': 'Aucun plan de traitement n’a été enregistré pour ce patient',
  'patient.plan.empty.description': 'Le plan de traitement est rédigé pendant une séance.',
  'patient.plan.noLines': 'Ce cycle de soins ne comporte encore aucune ligne.',
  'patient.plan.doneTitle': 'Soins réalisés',
  'patient.plan.outstanding': 'Soins restant à réaliser : {{count}} — {{amount}} au total',
  'patient.tabs.chart': 'Schéma dentaire',
  'chart.tooth': 'Dent',
  'chart.universalShort': 'N° US',
  'chart.annotation.planned': 'soin prévu',
  'chart.annotation.treated': 'traitée',
  'chart.legend.planned': 'Prévu',
  'chart.legend.treated': 'Traité',
  'chart.tooltip.treated': 'Soins réalisés',
  'chart.tooltip.andMore': 'et {{count}} de plus',
  'chart.tooltip.planned': 'Prévu',
  'chart.wholeMouth.title': 'Bouche entière',
  'chart.history.title': 'Historique de la dent {{fdi}}',
  'chart.history.treatment': 'Soin',
  'chart.history.event': 'Schéma',
  'chart.history.causedBy': 'issu du soin ci-dessus',
  'chart.history.empty': 'Rien n’a encore été enregistré pour cette dent.',
  'chart.history.unavailable': 'L’historique de cette dent n’a pas pu être lu.',
  'chart.history.session': 'Séance {{n}}',
  'chart.history.voided': 'Invalidé — {{reason}}',
  'chart.notCharted': 'Non renseignée',
  'chart.patientRight': 'DROITE DU PATIENT',
  'chart.patientLeft': 'GAUCHE DU PATIENT',
  'chart.aria.odontogram': 'Schéma dentaire — cliquez sur une dent ou une face pour l’enregistrer',
  'chart.hint': 'Cliquez sur une face pour l’enregistrer, ou sur la dent pour son état global.',

  // ── chart, mobile ────────────────────────────────────────────────────────
  'chart.mobile.settings': 'Paramètres du schéma',
  'chart.mobile.pickTooth': 'Choisir une dent',
  'chart.mobile.tapHint': 'Touchez une dent sur le schéma, ou choisissez-en une ci-dessous — les faces s’enregistrent dans le panneau qui s’ouvre.',
  'chart.mobile.legend': 'Légende',
  'chart.legend.bridge': 'Bridge',
  'chart.legend.wholeToothCaries': 'Carie de toute la dent',
  'chart.export.button': 'Exporter l’image',
  'chart.export.error': 'Impossible d’exporter l’image — ce navigateur ne le permet pas.',
  'chart.material': 'Matériau',
  'chart.isHistorical': 'Soin antérieur (non réalisé aujourd’hui)',
  'chart.showPrimary': 'Afficher les dents temporaires',
  'chart.hidePrimary': 'Masquer les dents temporaires',
  'chart.showUniversal': 'Afficher la numérotation américaine',
  'chart.hideUniversal': 'Masquer la numérotation américaine',
  'chart.error.title': 'Impossible de charger le schéma',
  'chart.error.body': 'Le schéma dentaire n’a pas pu être récupéré. Veuillez réessayer.',
  'chart.summary.charted': 'Renseignées',
  'chart.summary.decayed': 'Cariées',
  'chart.summary.restored': 'Obturées',
  'chart.summary.missing': 'Absentes',
  'chart.summary.dmft': 'Indice CAO',
  'chart.presence.title': 'Présence',
  'chart.presence.present': 'Présente',
  'chart.presence.extracted': 'Extraite',
  'chart.presence.exfoliated': 'Exfoliée',
  'chart.presence.congenitally_absent': 'Agénésie',
  'chart.presence.unerupted': 'Non érupée',
  'chart.presence.impacted': 'Incluse',
  'chart.surfaces.title': 'Faces',
  'chart.surfaces.hint': 'Choisissez une face, puis son état',
  'chart.surfaces.setFor': 'État pour',
  'chart.surface.M': 'Mésiale',
  'chart.surface.D': 'Distale',
  'chart.surface.F': 'Vestibulaire',
  'chart.surface.L': 'Linguale / palatine',
  'chart.surface.O': 'Occlusale',
  'chart.surface.I': 'Bord incisif',
  'chart.surfaceState.sound': 'Saine',
  'chart.surfaceState.caries': 'Cariée',
  'chart.surfaceState.restoration': 'Obturée',
  'chart.surfaceState.recurrent_caries': 'Carie secondaire',
  'chart.surfaceState.temporary': 'Obturation provisoire',
  'chart.surfaceState.sealant': 'Scellement de sillons',
  'chart.surfaceState.fractured': 'Fracturée',
  'chart.condition.title': 'Dent entière',
  'chart.condition.hint': 'Indépendamment des faces ci-dessus',
  'chart.conditionName.sound': 'Saine',
  'chart.conditionName.caries': 'Carie',
  'chart.conditionName.root_canal': 'Traitement endodontique',
  'chart.conditionName.post_core': 'Reconstitution corono-radiculaire',
  'chart.conditionName.crown': 'Couronne',
  'chart.conditionName.veneer': 'Facette',
  'chart.conditionName.implant': 'Implant',
  'chart.conditionName.bridge_abutment': 'Pilier de bridge',
  'chart.conditionName.bridge_pontic': 'Intermédiaire de bridge',
  'chart.conditionName.fracture': 'Fracture',
  'chart.conditionName.attrition': 'Attrition',
  'chart.conditionName.mobility': 'Mobilité',
  'chart.conditionName.periapical_lesion': 'Lésion périapicale',
  'chart.conditionName.sealant': 'Scellement de sillons',
  'chart.conditionName.temporary': 'Provisoire',
  'chart.conditionName.watch': 'À surveiller',
  'chart.note.title': 'Note',
  'chart.note.placeholder': 'Tout ce qui mérite d’être noté sur cette dent',
  'chart.materialName.composite': 'Composite',
  'chart.materialName.amalgam': 'Amalgame',
  'chart.materialName.glass_ionomer': 'Verre ionomère (CVI)',
  'chart.materialName.zirconia': 'Zircone',
  'chart.materialName.pfm': 'Céramo-métallique (CCM)',
  'chart.materialName.full_metal': 'Tout métal',
  'chart.materialName.emax': 'E.max',
  'chart.materialName.temporary': 'Provisoire',
  'chart.materialName.gold': 'Or',

  // ── hover card ──────────────────────────────────────────────────────────
  'chart.primary': 'temporaire',
  'chart.tooltip.notCharted': 'Rien n’a encore été enregistré pour cette dent.',
  'chart.tooltip.sound': 'Examinée — aucune anomalie',
  'chart.tooltip.lastRecorded': 'Dernier enregistrement',
  'chart.quadrant.upperRight': 'Supérieur droit (côté patient)',
  'chart.quadrant.upperLeft': 'Supérieur gauche (côté patient)',
  'chart.quadrant.lowerRight': 'Inférieur droit (côté patient)',
  'chart.quadrant.lowerLeft': 'Inférieur gauche (côté patient)',
  'chart.toothName.centralIncisor': 'Incisive centrale',
  'chart.toothName.lateralIncisor': 'Incisive latérale',
  'chart.toothName.canine': 'Canine',
  'chart.toothName.firstPremolar': 'Première prémolaire',
  'chart.toothName.secondPremolar': 'Deuxième prémolaire',
  'chart.toothName.firstMolar': 'Première molaire',
  'chart.toothName.secondMolar': 'Deuxième molaire',
  'chart.toothName.thirdMolar': 'Troisième molaire (dent de sagesse)',

  // ── جلسهٔ درمان — the visit workspace (docs/dent-visit.md) ────────────────
  'visit.error.title': 'La séance n’a pas pu être ouverte',
  'visit.error.body': 'Ce rendez-vous n’a pas pu être lu. Veuillez réessayer.',
  'visit.notFound.title': 'Séance introuvable',
  'visit.notFound.description': 'Ce rendez-vous n’existe pas, ne vous concerne pas ou n’est rattaché à aucun dossier patient.',
  'visit.unknownPatient': 'Patient sans nom',
  'visit.openRecord': 'Dossier patient',
  'visit.finish.action': 'Terminer la séance',
  'visit.finish.working': 'Clôture…',
  'visit.finish.confirm.title': 'Clôturer cette séance ?',
  'visit.finish.confirm.body': 'Les modifications non enregistrées sont enregistrées, puis la séance est clôturée. Elle passe ensuite en lecture seule et cette application ne peut pas la rouvrir.',
  'visit.finish.followUp.title': 'Soins restant dans le plan de traitement : {{count}}',
  'visit.finish.followUp.andMore': 'et {{count}} de plus',
  'visit.finish.followUp.today': 'Aujourd’hui',
  'visit.finish.followUp.tomorrow': 'Demain',
  'visit.finish.followUp.withinWeek': 'Sous une semaine',
  'visit.finish.followUp.within2Weeks': 'Sous deux semaines',
  'visit.finish.followUp.withinMonth': 'Sous un mois',
  'visit.finish.followUp.within3Months': 'Sous trois mois',
  'visit.finish.followUp.when': 'Dans quel délai le prochain rendez-vous doit-il avoir lieu ?',
  'visit.finish.followUp.none': 'Pas nécessaire',
  'visit.finish.followUp.deskNote': 'L’accueil sera prévenu afin de planifier ce rendez-vous avec vous.',
  'visit.finish.followUp.noneNote': 'L’accueil ne sera prévenu de rien.',
  'visit.finish.done.plain': 'La séance est clôturée.',
  'visit.finish.done.followUpRaised': 'La séance est clôturée. L’accueil a été invité à planifier la suivante.',
  'visit.finish.done.alreadyBooked': 'La séance est clôturée. Ce patient a déjà un prochain rendez-vous.',
  'visit.finish.done.followUpFailed': 'La séance est clôturée, mais l’accueil n’a pas été prévenu du prochain rendez-vous.',
  'visit.finish.error.subjective': 'La note de séance n’a pas été enregistrée, la séance n’a donc pas été clôturée. Réessayez.',
  'visit.finish.error.complete': 'La note de séance a été enregistrée, mais la séance n’a pas pu être clôturée. Réessayez.',

  // ── The video visit ──────────────────────────────────────────────────────
  'visit.call.start': 'Appel vidéo',
  'visit.call.title': 'Appel vidéo',
  'visit.call.panelLabel': 'Panneau d’appel vidéo',
  'visit.call.connecting': 'Connexion…',
  'visit.call.hangUp': 'Raccrocher',
  'visit.call.notRecorded': 'Cet appel n’est pas enregistré et rien n’en est conservé.',
  'visit.call.error.connection': 'L’appel n’a pas pu être établi. Vérifiez la connexion et réessayez.',
  'visit.call.error.unavailable': 'Les téléconsultations ne sont pas activées dans cet environnement.',
  'visit.call.error.visitOver': 'Cette séance est clôturée : aucun appel vidéo ne peut y être passé.',
  'visit.readOnly.badge': 'Lecture seule',
  'visit.readOnly.note': 'Cette séance est clôturée : plus rien ne peut y être enregistré. Tout ce qui est déjà enregistré reste affiché.',
  'visit.ai.costsCredits': 'Utilise du crédit IA.',
  'visit.tabs.meds': 'Médicaments',
  'visit.tabs.orders': 'Demandes',
  'visit.tabs.diagnosis': 'Diagnostic',
  'visit.tabs.questions': 'Questions',
  'visit.tabs.files': 'Fichiers',
  'visit.tabs.sectionsLabel': 'Sections de la séance',

  // ── §3.1.1 odontogram ───────────────────────────────────────────────────
  'visit.chart.title': 'Schéma dentaire',
  'visit.chart.hint': 'Sélectionnez une dent pour voir ses constatations et ce qui y est prévu.',
  'visit.chart.tooth': 'Dent {{fdi}}',
  'visit.chart.openTooth': 'Constatations',
  'visit.chart.planForTooth': 'Ajouter au plan',
  'visit.chart.noPlanForTooth': 'Rien n’est prévu sur cette dent.',
  'visit.chart.history': 'Historique',
  'visit.chart.noHistory': 'Rien n’a été enregistré pour cette dent.',
  'visit.chart.historyUnavailable': 'L’historique n’a pas pu être chargé.',
  'visit.chart.historical': 'antérieur',

  // ── §3.1.2 subjective ───────────────────────────────────────────────────
  'visit.subjective.title': 'Anamnèse',
  'visit.subjective.error.title': 'Impossible de charger la note de séance',
  'visit.subjective.error.body': 'La note de cette séance n’a pas pu être lue. Veuillez réessayer.',
  'visit.subjective.saved': 'Enregistré',
  'visit.subjective.saveFailed': 'La note de séance n’a pas pu être enregistrée. Veuillez réessayer.',
  'visit.subjective.history': 'Antécédents du patient',
  'visit.subjective.noAllergies': 'Aucune allergie enregistrée',
  'visit.subjective.conditions': 'Pathologies',
  'visit.subjective.medications': 'Médicaments',
  'visit.subjective.chiefComplaint': 'Motif de consultation',
  'visit.subjective.dictateComplaint': 'Dicter le motif de consultation',
  'visit.subjective.dictateNotes': 'Dicter la note',
  'visit.subjective.teeth': 'Dents concernées',
  'visit.subjective.noTeeth': 'Touchez les dents sur le schéma ci-dessus',
  'visit.subjective.addTooth': 'Ajouter la dent {{fdi}}',
  'visit.subjective.selectToothFirst': 'Sélectionnez une dent sur le schéma',
  'visit.subjective.painScore': 'Douleur (0–10)',
  'visit.subjective.painCharacter': 'Type de douleur',
  'visit.subjective.pain.sharp': 'Vive',
  'visit.subjective.pain.dull': 'Sourde',
  'visit.subjective.pain.throbbing': 'Pulsatile',
  'visit.subjective.pain.sensitivity': 'Sensibilité',
  'visit.subjective.pain.none': 'Aucune douleur',
  'visit.subjective.onset': 'Début',
  'visit.subjective.duration': 'Durée',
  'visit.subjective.aggravating': 'Aggravée par',
  'visit.subjective.relieving': 'Soulagée par',
  'visit.subjective.dentalHistory': 'Antécédents dentaires',
  'visit.subjective.notes': 'Notes',
  'visit.subjective.priorVisits': 'Séances précédentes',
  'visit.subjective.noPriorVisits': 'Aucune séance précédente enregistrée.',
  'visit.subjective.priorNoSummary': 'Aucun motif enregistré',
  'visit.subjective.priorDiagnoses': 'Diagnostics : {{count}}',

  // ── §3.1.3 treatment plan ───────────────────────────────────────────────
  'visit.plan.title': 'Plan de traitement',
  'visit.plan.error.title': 'Impossible de charger le plan',
  'visit.plan.error.body': 'Le plan de traitement de ce patient n’a pas pu être lu. Veuillez réessayer.',
  'visit.plan.error.currencyUnavailable': 'La devise du cabinet n’a pas pu être lue ; sans elle, les montants du plan ne peuvent pas être affichés. Veuillez réessayer.',
  'visit.plan.error.currencyMismatch': 'Ces montants ne sont pas dans la devise du cabinet, et des montants en devises différentes ne sont jamais additionnés. Demandez au responsable du cabinet de vérifier la devise du cabinet.',
  'visit.plan.saveFailed': 'Le plan n’a pas pu être enregistré.',
  'visit.plan.empty.title': 'Aucun plan pour l’instant',
  'visit.plan.empty.description': 'Ajoutez les soins que vous prévoyez de réaliser, dent par dent.',
  'visit.plan.add': 'Ajouter un soin',
  'visit.plan.added': 'Soin « {{what}} » ajouté au plan de traitement.',
  'visit.plan.addedForTooth': 'Soin « {{what}} » ajouté au plan de traitement pour la dent {{fdi}}.',
  'visit.chart.planFormOpened': 'Formulaire d’ajout ouvert pour la dent {{fdi}} — choisissez le soin.',
  'visit.plan.addItem': 'Ajouter au plan',
  'visit.plan.service': 'Soin',
  'visit.plan.choose': 'Choisir un soin…',
  'visit.plan.tooth': 'Dent',
  'visit.plan.wholeMouth': 'Bouche entière',
  'visit.plan.wholeMouthShort': 'Bouche',
  'visit.plan.phase': 'Phase',
  'visit.plan.description': 'Description',
  'visit.plan.untitledItem': 'Soin sans titre',
  'visit.plan.changeStatus': 'Modifier le statut de {{item}}',
  'visit.plan.remove': 'Retirer {{item}}',
  'visit.plan.showOnChart': 'Afficher sur le schéma',
  'visit.plan.surfaces': 'Faces',
  'visit.plan.sessions': 'Séances',
  'visit.plan.sessionsOf': 'Séance {{done}} sur {{total}}',
  'visit.plan.toman': '{{amount}} {{unit}}',
  'visit.plan.noTariff': 'Aucun tarif défini',
  'visit.plan.outstanding': 'Reste à réaliser : {{amount}}',
  'visit.plan.otherCurrency': 'Tarif dans une autre devise ({{currency}})',
  'visit.plan.otherCurrencyRefused': 'Le tarif de « {{name}} » est en {{currency}} : il ne peut pas être ajouté à un plan en {{planCurrency}}.',
  'visit.record.openVisit': 'Ouvrir la séance',
  'visit.record.open': 'Enregistrer comme réalisé',
  'visit.record.openSession': 'Enregistrer la séance',
  'visit.record.title': 'Enregistrer comme réalisé — {{treatment}}',
  'visit.record.subtitle': 'Enregistre ce qui a été fait pendant cette séance. C’est le dossier clinique.',
  'visit.record.service': 'Soin réalisé',
  'visit.record.tooth': 'Dent',
  'visit.record.surfaces': 'Faces',
  'visit.record.material': 'Matériau',
  'visit.record.noMaterial': 'Aucun matériau',
  'visit.record.note': 'Ce qui a été fait',
  'visit.record.notePlaceholder': 'En bref, ce qui a été fait',
  'visit.record.outcome': 'Résultat',
  'visit.record.outcome.completed': 'Terminé',
  'visit.record.outcome.inProgress': 'Se poursuit à la prochaine séance',
  'visit.record.chartEffect': 'État de la dent après le soin',
  'visit.record.chartEffect.none': 'Ne pas modifier le schéma',
  'visit.record.chartEffect.noneDetail': 'Rien ne sera inscrit sur le schéma dentaire.',
  'visit.record.chartEffect.detail': 'La dent {{tooth}} sera enregistrée sur le schéma comme « {{state}} ».',
  'visit.record.chartEffect.detailSurfaces': 'Les faces {{surfaces}} de la dent {{tooth}} seront enregistrées sur le schéma comme « {{state}} ».',
  'visit.record.chartEffect.needsSurfaces': 'Choisissez les faces traitées, sinon rien ne sera inscrit sur le schéma.',
  'visit.record.chartEffect.surfaceOption': 'Faces — {{state}}',
  'visit.record.chartEffect.inProgress': 'Cette séance ne termine pas le soin : par défaut, rien n’est inscrit sur le schéma.',
  'visit.record.billingNote': 'La facturation et le stock sont enregistrés séparément, après cet enregistrement ; ce formulaire n’enregistre aucun montant.',
  'visit.record.save': 'Enregistrer',
  'visit.record.saved': 'Soin « {{what}} » enregistré.',
  'visit.record.failed': 'Le soin n’a pas pu être enregistré.',
  'visit.record.doneHere': 'Réalisés pendant cette séance ({{count}})',
  'visit.record.void': 'Invalider',
  'visit.record.voidReason': 'Motif d’invalidation',
  'visit.record.voidedFor': 'Invalidé — {{reason}}',
  'visit.record.voidConfirm.title': 'Invalider « {{what}} » ?',
  'visit.record.voidConfirm.body': 'La ligne n’est pas supprimée : elle reste dans le dossier, barrée, avec le motif que vous indiquez. Le motif est obligatoire.',
  'visit.record.notBilled': 'Non facturé',
  'visit.record.voidConfirm.alsoChart': 'Invalider aussi ce qui a été inscrit pour la dent {{tooth}} sur le schéma',
  'visit.record.voidConfirm.stillBilled': 'Ce soin figure déjà sur la facture du patient. L’invalider retire automatiquement le montant — sous forme de ligne d’avoir si la facture a été émise.',
  'visit.record.voidCharge.notReversed': 'Le soin a été invalidé, mais son montant n’a pas pu être retiré de la facture. Demandez à la caisse de la corriger.',
  'visit.record.billed': 'Ajouté à la facture de cette séance.',
  'visit.plan.noServices.title': 'Cette clinique n’a encore défini aucune prestation',
  'visit.plan.noServices.body': 'Les lignes du plan de traitement proviennent des prestations de la clinique. Définissez les prestations dentaires et leurs tarifs dans l’espace clinique.',
  'visit.plan.noServices.action': 'Définir les prestations dans l’espace clinique',
  'visit.plan.catalogUnavailable': 'La liste des prestations de la clinique n’a pas pu être lue. Cela ne veut pas dire qu’il n’y en a aucune — réessayez.',
  'visit.plan.applicability.unset': 'Non précisé',
  'visit.plan.applicability.tooth': 'Une dent',
  'visit.plan.applicability.surfaces': 'Faces d’une dent',
  'visit.plan.applicability.quadrant': 'Un quadrant',
  'visit.plan.applicability.arch': 'Une arcade',
  'visit.plan.applicability.mouth': 'Bouche entière',
  'visit.plan.newService.title': 'Nouvelle prestation',
  'visit.plan.newService.subtitle': 'Ajoutée aux prestations de la clinique et proposée dès lors à tous vos collègues.',
  'visit.plan.newService.name': 'Nom de la prestation',
  'visit.plan.newService.category': 'Groupe',
  'visit.plan.newService.chartEffect': 'Effet sur le schéma',
  'visit.plan.newService.applicability': 'S’applique à',
  'visit.plan.newService.tariff': 'Tarif par séance ({{unit}})',
  'visit.plan.newService.duration': 'Minutes par séance',
  'visit.plan.newService.tariffHint': 'Le tarif peut rester vide : la prestation est enregistrée sans tarif et n’est pas facturée tant qu’aucun tarif n’est défini.',
  'visit.plan.newService.clinicOnly.title': 'À compléter dans l’espace clinique',
  'visit.plan.newService.clinicOnly.body': 'Consommables, autres coûts, commission et assurance.',
  'visit.plan.newService.save': 'Enregistrer et sélectionner',
  'visit.plan.newService.created': 'La prestation « {{name}} » a été ajoutée aux prestations de la clinique.',
  'visit.plan.newService.nameRequired': 'Le nom de la prestation est obligatoire.',
  'visit.plan.newService.failed': 'La prestation n’a pas pu être enregistrée.',
  'visit.plan.newService.badTariff': 'Le tarif doit être un nombre, en {{unit}}.',
  'visit.plan.newService.currencyUnknown': 'La devise de ce cabinet n’a pas pu être lue : le tarif ne peut donc pas être saisi ici. La prestation est enregistrée sans tarif ; définissez-le dans l’espace clinique.',
  'visit.plan.noClinic': 'Cette séance n’est rattachée à aucune clinique ; sans clinique, les prestations et les tarifs ne peuvent pas être lus.',
  'common.form.optional': '(facultatif)',
  'visit.plan.locked': 'Signé',
  'visit.plan.startNew': 'Commencer un nouveau cycle',
  'visit.plan.lockedNextStep': 'Ajouter un soin ouvre un nouveau cycle de traitement.',
  'visit.plan.lockedNote': 'Ce plan a été approuvé et signé : ses lignes ne peuvent plus être modifiées. Les soins peuvent toujours être marqués comme réalisés.',
  'visit.plan.phases.emergency': 'Urgence',
  'visit.plan.phases.phase1': 'Phase 1',
  'visit.plan.phases.phase2': 'Phase 2',
  'visit.plan.phases.maintenance': 'Maintenance',
  'visit.plan.status.proposed': 'Proposé',
  'visit.plan.status.accepted': 'Accepté',
  'visit.plan.status.done': 'Réalisé',
  'visit.plan.status.rejected': 'Refusé',
  'visit.plan.status.deferred': 'Reporté',
  'visit.plan.planStatus.draft': 'Brouillon',
  'visit.plan.planStatus.proposed': 'Proposé',
  'visit.plan.planStatus.approved': 'Approuvé',
  'visit.plan.planStatus.in_progress': 'En cours',
  'visit.plan.planStatus.completed': 'Terminé',
  'visit.plan.planStatus.abandoned': 'Abandonné',

  // ── §3.2.1 medication ───────────────────────────────────────────────────
  'visit.meds.empty.title': 'Aucune prescription pour l’instant',
  'visit.meds.empty.description': 'Recherchez dans le référentiel ci-dessus pour ajouter un médicament à cette séance.',
  'visit.meds.thisVisit': 'Prescrit pendant cette séance',
  'visit.meds.current': 'Traitement en cours',
  'visit.meds.suggest': 'Suggestions de l’IA',
  'visit.meds.suggesting': 'Analyse en cours…',
  'visit.meds.suggestions': 'Médicaments suggérés',
  'visit.meds.suggestClose': 'Ignorer les suggestions',
  'visit.meds.suggestAdd': 'Ajouter à l’ordonnance',
  'visit.meds.suggestAdded': 'Ajouté',
  'visit.meds.noSuggestions': 'Aucune suggestion. Enregistrez d’abord le diagnostic ou l’évaluation de cette séance — l’analyse s’appuie sur ce qui a été rédigé pour cette séance.',
  'visit.meds.suggestUnavailable': 'Les suggestions de l’IA sont indisponibles.',
  'visit.meds.followUp': 'Suivi :',

  // ── §3.2.2 orders — dental lab and imaging only ─────────────────────────
  'visit.orders.error.title': 'Impossible de charger les demandes',
  'visit.orders.error.body': 'Les demandes de cette séance n’ont pas pu être lues. Veuillez réessayer.',
  'visit.orders.saveFailed': 'La demande n’a pas pu être enregistrée.',
  'visit.orders.empty.title': 'Aucune demande pendant cette séance',
  'visit.orders.empty.description': 'Demandez une radiographie ou envoyez un cas au laboratoire de prothèse.',
  'visit.orders.type': 'Type de demande',
  'visit.orders.types.imaging': 'Imagerie',
  'visit.orders.types.lab': 'Biologie',
  'visit.orders.types.dental_lab': 'Laboratoire de prothèse',
  'visit.orders.service': 'Prestation',
  'visit.orders.serviceScope': 'Prestations « {{type}} » uniquement',
  'visit.orders.choose': 'Choisir une prestation…',
  'visit.orders.description': 'Description',
  'visit.orders.descriptionHint': 'Laisser vide pour utiliser le nom de la prestation',
  'visit.orders.notes': 'Notes pour le laboratoire de prothèse / la radiologie',
  'visit.orders.urgency': 'Priorité',
  'visit.orders.urgencies.routine': 'Normal',
  'visit.orders.urgencies.urgent': 'Urgent',
  'visit.orders.urgencies.stat': 'Très urgent',
  'visit.orders.sessions': 'Séances',
  'visit.orders.sessionCount': 'Séances : {{count}}',
  'visit.orders.add': 'Envoyer la demande',
  'visit.orders.statuses.pending': 'En attente',
  'visit.orders.statuses.in_progress': 'En cours',
  'visit.orders.statuses.completed': 'Terminée',
  'visit.orders.statuses.cancelled': 'Annulée',
  'visit.orders.transitions.start': 'Démarrer',
  'visit.orders.transitions.complete': 'Marquer comme terminée',
  'visit.orders.transitions.cancel': 'Annuler',
  'visit.orders.suggest': 'Suggestions de l’IA',
  'visit.orders.suggesting': 'Analyse en cours…',
  'visit.orders.suggestions': 'Demandes suggérées',
  'visit.orders.suggestClose': 'Ignorer les suggestions',
  'visit.orders.suggestAdd': 'Envoyer la demande',
  'visit.orders.suggestAdded': 'Envoyée',
  'visit.orders.noSuggestions': 'Aucune suggestion. Enregistrez d’abord le diagnostic ou l’évaluation de cette séance — l’analyse s’appuie sur ce qui a été rédigé pour cette séance.',
  'visit.orders.suggestUnavailable': 'Les suggestions de l’IA sont indisponibles.',
  'visit.orders.suggestDropped': 'Suggestions hors du catalogue dentaire, non affichées : {{count}}',

  // ── §3.2.3 diagnosis, with click-to-reveal traceability ─────────────────
  'visit.diagnosis.error.title': 'Impossible de charger les diagnostics',
  'visit.diagnosis.error.body': 'Les diagnostics de cette séance n’ont pas pu être lus. Veuillez réessayer.',
  'visit.diagnosis.saveFailed': 'Le diagnostic n’a pas pu être enregistré.',
  'visit.diagnosis.empty.title': 'Aucun diagnostic enregistré',
  'visit.diagnosis.empty.description': 'Enregistrez votre conclusion : les constatations sur lesquelles elle repose sont conservées avec elle.',
  'visit.diagnosis.name': 'Diagnostic',
  'visit.diagnosis.code': 'Code CIM',
  'visit.diagnosis.certainty': 'Certitude',
  'visit.diagnosis.verification.provisional': 'Provisoire',
  'visit.diagnosis.verification.confirmed': 'Confirmé',
  'visit.diagnosis.add': 'Enregistrer le diagnostic',
  'visit.diagnosis.remove': 'Retirer {{name}}',
  'visit.diagnosis.willAttach': 'Éléments à l’appui qui seront enregistrés avec ce diagnostic : {{count}}.',
  'visit.diagnosis.evidence': 'Éléments ({{count}})',
  'visit.diagnosis.noEvidence': 'Aucun élément à l’appui n’a été enregistré avec ce diagnostic.',
  'visit.diagnosis.evidenceKind.subjective': 'Anamnèse',
  'visit.diagnosis.evidenceKind.history': 'Antécédents',
  'visit.diagnosis.evidenceKind.chart': 'Schéma',
  'visit.diagnosis.evidenceKind.file': 'Document',
  'visit.diagnosis.evidenceKind.order': 'Demande',
  'visit.diagnosis.evidenceKind.ai': 'Analyse de l’IA',
  'visit.diagnosis.showTooth': 'Afficher la dent',
  'visit.diagnosis.toothEvidence': 'Constatations sur la dent {{fdi}}',
  'visit.diagnosis.aiAssisted': 'Avec l’aide de l’IA',
  'visit.diagnosis.suggest': 'Suggestions de l’IA',
  'visit.diagnosis.suggesting': 'Analyse en cours…',
  'visit.diagnosis.suggestions': 'Diagnostics suggérés',
  'visit.diagnosis.noSuggestions': 'Aucune suggestion. Enregistrez d’abord l’anamnèse — l’analyse s’appuie sur ce qui a été rédigé pour cette séance.',
  'visit.diagnosis.suggestUnavailable': 'Les suggestions de l’IA sont indisponibles pour le moment.',
  'visit.diagnosis.accept': 'Enregistrer',
  'visit.diagnosis.alreadyRecorded': 'Enregistré',
  'visit.diagnosis.confidence.high': 'Confiance élevée',
  'visit.diagnosis.confidence.medium': 'Confiance moyenne',
  'visit.diagnosis.confidence.low': 'Confiance faible',

  // ── SOAP assistant — the diagnosis tab ──────────────────────────────────
  'visit.soap.title': 'Assistant de rédaction',
  'visit.soap.description': 'Dites ce qui s’est passé pendant la séance ; quand vous arrêtez, l’assistant complète les sections de la note de séance et donne des conseils sur le problème. Rien n’est enregistré sans votre approbation.',
  'visit.soap.speak': 'Dicter la séance',
  'visit.soap.speakStop': 'Terminer et obtenir des conseils',
  'visit.soap.analyzing': 'Analyse en cours…',
  'visit.soap.heard': 'Ce qui a été entendu :',
  'visit.soap.retry': 'Renvoyer',
  'visit.soap.voiceUnavailable': 'La dictée nécessite un micro et une connexion sécurisée (HTTPS), et n’est pas disponible dans ce navigateur.',
  'visit.soap.draftTitle': 'Proposition de note de séance',
  'visit.soap.sections.s': 'Anamnèse (S) — ajoutée aux notes',
  'visit.soap.sections.o': 'Examen clinique et constatations (O)',
  'visit.soap.sections.a': 'Évaluation (A)',
  'visit.soap.sections.p': 'Plan de traitement (P)',
  'visit.soap.apply': 'Appliquer à la note de séance',
  'visit.soap.applied': 'Inscrit dans la note de séance.',
  'visit.soap.applyFailed': 'La proposition n’a pas pu être appliquée.',
  'visit.soap.dismiss': 'Ignorer',
  'visit.soap.noNews': 'Rien de nouveau à ajouter à la note de séance.',
  'visit.soap.refineUnavailable': 'La complétion de la note de séance est indisponible.',
  'visit.soap.adviceTitle': 'Conseils de l’assistant',
  'visit.soap.adviceUnavailable': 'Les conseils de l’IA sont indisponibles.',
  'visit.soap.suggestedDiagnosis': 'Diagnostic suggéré',
  'visit.soap.recordDiagnosis': 'Enregistrer comme diagnostic',
  'visit.soap.accepted': 'Accepté — enregistré dans les diagnostics de cette séance.',
  'visit.soap.actions': 'Actions suggérées',
  'visit.soap.medications': 'Médicaments suggérés',
  'visit.soap.aiEvidence': 'Issu de l’analyse du récit de la séance',

  // ── Per-tooth findings from the narrative → the dental chart ──────────────
  'visit.soap.teeth.title': 'Constatations dentaires',
  'visit.soap.teeth.description': 'Ces éléments ont été repérés dans le récit de la séance comme concernant des dents précises. Ceux que vous confirmez sont enregistrés sur le schéma dentaire ; les autres ne le sont pas.',
  'visit.soap.teeth.lowConfidenceHint': 'Les lignes à faible confiance ne sont pas cochées — vérifiez le numéro de la dent avant de l’enregistrer.',
  'visit.soap.teeth.tooth': 'Dent {{fdi}}',
  'visit.soap.teeth.surface': 'Face {{surface}}',
  'visit.soap.teeth.historical': 'Antécédent',
  'visit.soap.teeth.record': 'Enregistrer sur le schéma ({{count}})',
  'visit.soap.teeth.recording': 'Enregistrement…',
  'visit.soap.teeth.recorded': 'Enregistré sur le schéma dentaire.',
  'visit.soap.teeth.recordFailed': 'Impossible d’enregistrer sur le schéma dentaire.',
  'visit.soap.teeth.none': 'Aucune constatation dentaire précise n’a été trouvée dans le récit.',
  'visit.soap.teeth.unavailable': 'La lecture des constatations dentaires est indisponible.',
  'visit.soap.teeth.confidence.high': 'Confiance élevée',
  'visit.soap.teeth.confidence.medium': 'Confiance moyenne',
  'visit.soap.teeth.confidence.low': 'Confiance faible',
  'tooth.aspect.presence': 'Présence de la dent',
  'tooth.aspect.condition': 'État de la dent',
  'tooth.aspect.surface': 'État de la face',
  'tooth.value.sound': 'Saine',
  'tooth.value.caries': 'Carie',
  'tooth.value.root_canal': 'Traitement endodontique',
  'tooth.value.post_core': 'Reconstitution corono-radiculaire',
  'tooth.value.crown': 'Couronne',
  'tooth.value.veneer': 'Facette',
  'tooth.value.implant': 'Implant',
  'tooth.value.bridge_abutment': 'Pilier de bridge',
  'tooth.value.bridge_pontic': 'Intermédiaire de bridge',
  'tooth.value.fracture': 'Fracture',
  'tooth.value.attrition': 'Attrition',
  'tooth.value.mobility': 'Mobilité',
  'tooth.value.periapical_lesion': 'Lésion périapicale',
  'tooth.value.sealant': 'Scellement de sillons',
  'tooth.value.temporary': 'Provisoire',
  'tooth.value.watch': 'À surveiller',
  'tooth.value.restoration': 'Obturation',
  'tooth.value.recurrent_caries': 'Carie secondaire',
  'tooth.value.fractured': 'Fracturée',
  'tooth.value.present': 'Présente',
  'tooth.value.extracted': 'Extraite',
  'tooth.value.exfoliated': 'Exfoliée',
  'tooth.value.congenitally_absent': 'Agénésie',
  'tooth.value.unerupted': 'Non érupée',
  'tooth.value.impacted': 'Incluse',
  'tooth.material.composite': 'Composite',
  'tooth.material.amalgam': 'Amalgame',
  'tooth.material.glass_ionomer': 'Verre ionomère (CVI)',
  'tooth.material.zirconia': 'Zircone',
  'tooth.material.pfm': 'CCM',
  'tooth.material.full_metal': 'Tout métal',
  'tooth.material.emax': 'E.max',
  'tooth.material.temporary': 'Provisoire',
  'tooth.material.gold': 'Or',

  // ── §3.2.4 questions — the clinical assistant ───────────────────────────
  'visit.questions.title': 'Assistant clinique',
  'visit.questions.forDiagnoses': 'Questions qui permettraient de confirmer ou d’écarter : {{list}}',
  'visit.questions.noDiagnosesYet': 'Aucun diagnostic enregistré pour l’instant — l’assistant posera des questions sur le motif que vous avez rédigé.',
  'visit.questions.generate': 'Repérer les points à éclaircir',
  'visit.questions.generating': 'Réflexion…',
  'visit.questions.unavailable': 'L’assistant clinique est indisponible pour le moment.',
  'visit.questions.fallbackNote': 'Ce sont des questions générales, et non des questions rédigées pour ce patient.',
  'visit.questions.empty.title': 'Aucune question en suspens',
  'visit.questions.empty.description': 'Rien de plus n’est nécessaire pour étayer les diagnostics actuels.',
  'visit.questions.count': 'Questions : {{count}}',
  'visit.questions.yes': 'Oui',
  'visit.questions.no': 'Non',
  'visit.questions.recorded': 'Enregistré : {{statement}}',
  'visit.questions.recordFailed': 'La réponse n’a pas pu être enregistrée dans la note de séance.',
  'visit.questions.askTitle': 'Demander à l’assistant',
  'visit.questions.askPlaceholder': 'Posez une question sur ce patient…',
  'visit.questions.ask': 'Demander',
  'visit.questions.asking': 'Envoi de la question…',
  'visit.questions.followUps': 'Suivi',

  // ── §3.2.5 files, and the report each one produced ──────────────────────

  // ── فایل‌ها: what kind of thing is being uploaded ────────────────────────
  'visit.files.kind': 'De quoi s’agit-il ?',
  'visit.files.kinds.image': 'Image dentaire',
  'visit.files.kinds.document': 'Document',
  'visit.files.viewType': 'Incidence',
  'visit.files.viewTypes.periapical': 'Rétro-alvéolaire',
  'visit.files.viewTypes.bitewing': 'Rétro-coronaire (bite-wing)',
  'visit.files.viewTypes.panoramic': 'Panoramique dentaire',
  'visit.files.viewTypes.ceph': 'Téléradiographie de profil',
  'visit.files.viewTypes.photo': 'Photographie',
  'visit.files.plainUploadNote': 'L’import se contente de stocker le fichier. L’extraction du texte et la lecture de l’image sont des actions distinctes.',
  'visit.files.unsupportedImage': 'Ce format d’image ne peut pas être affiché. Utilisez JPEG ou PNG.',
  'visit.files.openImage': 'Ouvrir l’image',
  'visit.files.extract': 'Extraire le texte',
  'visit.files.extracting': 'Extraction…',

  // ── The image workspace ─────────────────────────────────────────────────
  'visit.image.back': 'Retour aux fichiers',
  'visit.image.tools': 'Outils de dessin',
  'visit.image.tool.cursor': 'Sélectionner',
  'visit.image.tool.pin': 'Repère',
  'visit.image.tool.box': 'Rectangle',
  'visit.image.tool.ellipse': 'Cercle',
  'visit.image.tool.arrow': 'Flèche',
  'visit.image.tool.freehand': 'Main levée',
  'visit.image.color': 'Couleur du crayon',
  'visit.image.colorName.E11D48': 'Rouge',
  'visit.image.colorName.F59E0B': 'Ambre',
  'visit.image.colorName.0EA5A0': 'Turquoise',
  'visit.image.colorName.2563EB': 'Bleu',
  'visit.image.zoomIn': 'Zoom avant',
  'visit.image.zoomOut': 'Zoom arrière',
  'visit.image.fit': 'Réinitialiser la vue',
  'visit.image.brightness': 'Luminosité',
  'visit.image.contrast': 'Contraste',
  'visit.image.read': 'Lire l’image',
  'visit.image.reading': 'Lecture…',
  'visit.image.readStatus.no_findings': 'L’assistant n’a rien trouvé de notable sur cette image. Aucun crédit n’a été débité.',
  'visit.image.readStatus.no_image': 'L’image n’a pas pu être lue.',
  'visit.image.comment': 'Note sur ce repère',
  'visit.image.commentPlaceholder': 'Qu’avez-vous observé ici ?',
  'visit.image.removeMark': 'Supprimer ce repère',
  'visit.image.tooManyMarks': 'Une image peut contenir au maximum {{max}} repères.',
  'visit.image.saveFailed': 'Les repères n’ont pas pu être enregistrés.',
  'visit.image.unsaved': 'Repères non enregistrés — appuyez sur « Enregistrer ».',
  'visit.image.findings': 'Ce que l’assistant a lu',
  'visit.image.findingsNote': 'Ce sont des suggestions. Rien n’est inscrit sur le schéma sans votre confirmation.',
  'visit.image.confidence.high': 'Nette',
  'visit.image.confidence.medium': 'Probable',
  'visit.image.confidence.low': 'Incertaine',
  'visit.image.notLocalized': 'emplacement non identifié',
  'visit.image.unlocalizedNote': 'Constatations non localisables sur l’image, simplement listées : {{count}}',
  'visit.image.confirm': 'Confirmer',
  'visit.files.openFile': 'Ouvrir le fichier',
  'visit.image.register': 'Enregistrer',
  'visit.image.registering': 'Enregistrement…',
  'visit.image.notRegistered.title': 'Non enregistrée comme image dentaire',
  'visit.image.notRegistered.body': 'Vous pouvez la consulter. Pour l’annoter et la faire lire par l’assistant, il faut préciser l’incidence — une rétro-coronaire et une photographie ne montrent pas les mêmes choses.',
  'visit.image.changeView': 'Changer l’incidence',
  'visit.image.viewType.title': 'Incidence',
  'visit.image.viewType.body': 'Ce choix détermine ce que l’assistant peut signaler — une rétro-coronaire ne montre pas une lésion périapicale, et une photographie ne montre pas l’os. Corrigez-le s’il est erroné.',
  'visit.image.discard.title': 'Abandonner les repères dessinés ?',
  'visit.image.discard.body': 'Ils n’ont pas été enregistrés et il n’en existe aucune autre copie.',
  'visit.image.discard.confirm': 'Abandonner',
  'visit.files.error.title': 'Impossible de charger les fichiers',
  'visit.files.error.body': 'Les documents de ce patient n’ont pas pu être lus. Veuillez réessayer.',
  'visit.files.empty.title': 'Aucun document',
  'visit.files.empty.description': 'Importez une radiographie, un résultat d’analyse ou une lettre d’orientation.',
  'visit.files.upload': 'Importer un document',
  'visit.files.uploading': 'Import…',
  'visit.files.uploadFailed': 'Le document n’a pas pu être importé.',
  'visit.files.readFailed': 'Le fichier n’a pas pu être lu.',
  'visit.files.tooLarge': 'Le fichier dépasse 15 Mo.',
  'visit.files.docType': 'Type de document',
  'visit.files.docTypes.lab_report': 'Résultat d’analyse',
  'visit.files.docTypes.prescription': 'Ordonnance',
  'visit.files.docTypes.general': 'Autre',
  'visit.files.attachTooth': 'Rattacher à la dent {{fdi}}',
  'visit.files.thisVisit': 'Cette séance',
  'visit.files.hasReport': 'Compte rendu',
  'visit.files.noReport': 'Aucun compte rendu n’a été extrait de ce document.',
  'visit.files.previewFailed': 'Le fichier n’a pas pu être ouvert.',
  'visit.files.bytesGone': 'Le fichier d’origine n’est plus conservé ; seul son compte rendu subsiste.',
  'visit.files.remove': 'Supprimer {{name}}',
  'visit.files.units.b': 'o',
  'visit.files.units.kb': 'Ko',
  'visit.files.units.mb': 'Mo',

  // ── credits (اعتبار) ──────────────────────────────────────────────────────
  'credits.title': 'Crédit Parsina',
  'credits.subtitle': 'Votre solde Parseh, son utilisation et les moyens de le recharger.',
  'credits.unit': 'Parseh',
  'credits.toman': 'tomans',
  'credits.tomanShort': 'T',
  'credits.currentBalance': 'Solde actuel',
  'credits.buy': 'Acheter des Parseh',
  'credits.topUp': 'Recharger',
  'credits.percent': '{{value}} %',
  'credits.timesUsed': '{{count}} fois',
  'credits.itemCount': 'opérations : {{count}}',
  'credits.minutesUsed': '{{count}} min',
  'credits.byService': 'Répartition par service',
  'credits.transactions': 'Opérations',
  'credits.level.low': 'Solde faible',
  'credits.level.lowShort': 'Faible',
  'credits.level.mid': 'Solde en baisse',
  'credits.level.midShort': 'Moyen',
  'credits.level.ok': 'Solde suffisant',
  'credits.level.okShort': 'Bon',
  'credits.banner.low': 'Il ne reste que {{coins}} Parseh. L’assistant s’arrêtera une fois le crédit épuisé.',
  'credits.banner.mid': 'Il reste {{coins}} Parseh — de quoi tenir encore quelques séances.',
  'credits.service.assistant': 'Assistant clinique',
  'credits.service.interaction': 'Vérification des interactions',
  'credits.service.transcription': 'Transcription',
  'credits.service.topUp': 'Recharge',
  'credits.service.gift': 'Code cadeau',
  'credits.service.sms': 'SMS',
  'credits.service.ai': 'Service IA',
  'credits.filter.label': 'Filtrer les opérations',
  'credits.filter.all': 'Toutes',
  'credits.filter.spend': 'Consommation',
  'credits.filter.topUp': 'Ajouts',
  'credits.group.label': 'Regrouper par',
  'credits.group.day': 'Jour',
  'credits.group.type': 'Service',
  'credits.range.label': 'Période',
  'credits.range.all': 'Toute la période',
  'credits.range.days7': '7 derniers jours',
  'credits.range.days30': '30 derniers jours',
  'credits.range.thisMonth': 'Ce mois-ci',
  'credits.time.today': 'Aujourd’hui',
  'credits.time.yesterday': 'Hier',
  'credits.kpi.month': 'Consommé ce mois-ci',
  'credits.kpi.perVisit': 'Par séance',
  'credits.kpi.topService': 'Premier poste de consommation',
  'credits.showingRange': 'Affichage : {{from}}–{{to}} sur {{total}}',
  'credits.pager.page': 'Page {{page}} sur {{total}}',
  'credits.pager.previous': 'Précédent',
  'credits.pager.next': 'Suivant',
  'credits.empty.title': 'Aucune opération pour l’instant',
  'credits.empty.hint': 'Chaque action de l’assistant pendant une séance apparaît ici.',
  'credits.empty.filtered': 'Aucune opération sur cette période',
  'credits.empty.filteredHint': 'Essayez une période plus large ou un autre filtre.',
  'credits.error.title': 'Opérations indisponibles',
  'credits.error.body': 'Votre solde n’a pas pu être lu. Aucun crédit n’a été débité.',
  'credits.priceList.title': 'Coût de chaque action',
  'credits.priceList.hint': 'Débité uniquement lorsque vous appuyez sur le bouton — rien ne se lance tout seul.',
  'credits.priceList.viewAll': 'Tout afficher',
  'credits.price.transcription': 'Dictée vocale (reconnaissance vocale)',
  'credits.price.differential': 'Suggestion de diagnostic par l’IA',
  'credits.price.advice': 'Conseils de l’assistant',
  'credits.price.soap': 'Compléter la note',
  'credits.price.teeth': 'Constatations par dent à partir du compte rendu de séance',
  'credits.price.confirmq': 'Questions de confirmation',
  'credits.price.ask': 'Demander à l’assistant',
  'credits.price.ocr': 'Lecture d’un document importé',
  'credits.price.interaction': 'Vérification des interactions médicamenteuses',
  'credits.topUp.chooseAmount': 'Choisir un montant',
  'credits.topUp.recommended': 'Recommandé',
  'credits.topUp.approxVisits': 'Séances avec l’assistant : environ {{count}}',
  'credits.topUp.custom': 'Autre montant',
  'credits.topUp.customAria': 'Montant',
  'credits.topUp.payVia': 'Payer {{amount}} tomans via {{gateway}}',
  'credits.topUp.enterAmount': 'Saisissez un montant',
  'credits.topUp.redirecting': 'Redirection vers la passerelle…',
  'credits.topUp.redirectNote': 'La passerelle de paiement bancaire va s’ouvrir, puis vous reviendrez sur cette page.',
  'credits.topUp.minimum': 'L’achat minimum est de {{amount}} tomans.',
  'credits.topUp.failed': 'Le paiement n’a pas pu être lancé. Veuillez réessayer.',
  'credits.topUp.failedWithReason': 'Le paiement n’a pas pu être lancé : {{reason}}',
  'credits.gateway.saderat': 'Bank Saderat',
  'credits.gateway.zarinpal': 'Zarinpal',
  'credits.payment.done': 'Paiement réussi — votre solde a été rechargé.',
  'credits.payment.failed': 'Le paiement n’a pas abouti. Aucun montant n’a été débité.',
  'credits.gift.title': 'Code cadeau',
  'credits.gift.hint': 'Vous avez un code reçu lors d’une campagne Parsina ? Saisissez-le ici : le crédit Parseh correspondant sera ajouté à votre solde.',
  'credits.gift.placeholder': 'PARSINA-1404-XXXX',
  'credits.gift.submit': 'Activer',
  'credits.gift.submitting': 'Activation…',
  'credits.gift.empty': 'Saisissez d’abord le code.',
  'credits.gift.notFound': 'Ce code n’est pas valide. Saisissez-le exactement tel que vous l’avez reçu.',
  'credits.gift.oneUse': 'Chaque code ne peut être utilisé qu’une seule fois.',
  'credits.gift.success': 'Crédit ajouté : {{parseh}} Parseh',
  'credits.gift.successSub': 'Séances avec l’assistant : environ {{visits}}.',
  'credits.gift.newBalance': 'Nouveau solde',
  'credits.gift.myCodes': 'Vos codes',
  'credits.gift.worth': '{{parseh}} Parseh — séances : environ {{visits}}',
  'credits.gift.status.issued': 'Non utilisé',
  'credits.gift.status.redeemed': 'Utilisé',
  'credits.gift.status.revoked': 'Révoqué',
  'credits.gift.status.expired': 'Expiré',
  'credits.lowBalance.title': 'Alerte de solde faible',
  'credits.lowBalance.hint': 'Nous vous préviendrons lorsque votre solde passera sous ce seuil.',
  'credits.lowBalance.toggleAria': 'Activer les alertes de solde faible',
  'credits.lowBalance.thresholdAria': 'Seuil d’alerte, en Parseh',
  'credits.lowBalance.active': 'Une alerte vous sera envoyée sous {{coins}} Parseh.',
  'credits.lowBalance.off': 'Les alertes sont désactivées.',
  'credits.lowBalance.invalid': 'Saisissez un seuil valide.',
  'credits.lowBalance.saved': 'Paramètres d’alerte enregistrés.',
  'credits.lowBalance.failed': 'Les paramètres d’alerte n’ont pas pu être enregistrés.',
};
